(() => {
  'use strict';
  const tag = 'cm-arrival-classic-photo';
  if (!customElements.get(tag)) {
    customElements.define(tag, class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const mainLink = this.querySelector('[data-gallery-main]');
        const main = mainLink?.querySelector('img');
        const thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        if (!main) return;
        thumbs.forEach(thumb => thumb.addEventListener('click', () => {
          const image = thumb.querySelector('img');
          if (!image) return;
          main.setAttribute('sizes', this.dataset.mainSizes);
          ['width', 'height', 'alt', 'srcset', 'src'].forEach(name => {
            if (image.hasAttribute(name)) main.setAttribute(name, image.getAttribute(name));
            else main.removeAttribute(name);
          });
          mainLink.dataset.index = thumb.dataset.index;
          thumbs.forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
          const status = this.querySelector('[data-gallery-status]');
          if (status) status.textContent = this.dataset.statusLabel.replace('__NUMBER__', thumb.dataset.index);
        }, {signal: this.controller.signal}));
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  const elementTag = 'cm-arrival-soft-controller';
  if (customElements.get(elementTag)) return;
  customElements.define(elementTag, class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const section = this.closest('[data-arrival-classic]');
      const track = section?.querySelector('[data-arrival-track]');
      if (!track) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const cards = Array.from(track.querySelectorAll('[data-arrival-card]'));
      const previous = section.querySelector('[data-arrival-prev]');
      const next = section.querySelector('[data-arrival-next]');
      const position = section.querySelector('[data-arrival-position]');
      let current = 0;
      let pending = false;
      let timer = 0;
      let frame = 0;
      const visibleCount = () => matchMedia('(min-width: 641px)').matches ? 2 : 1;
      const lastIndex = () => Math.max(0, cards.length - visibleCount());
      const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const target = index => Math.max(0, Math.min(maxScroll(), cards[index].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft));
      const paint = () => {
        previous.disabled = !cards.length || current === 0;
        next.disabled = !cards.length || current >= lastIndex();
        const end = Math.min(cards.length, current + visibleCount());
        position.textContent = cards.length ? `${current + 1}${end > current + 1 ? `–${end}` : ''} / ${cards.length}` : '0 / 0';
      };
      const nearest = () => {
        if (!cards.length) return;
        let best = 0;
        for (let index = 1; index <= lastIndex(); index++) {
          if (Math.abs(target(index) - track.scrollLeft) < Math.abs(target(best) - track.scrollLeft)) best = index;
        }
        current = best;
        paint();
      };
      const settle = () => { pending = false; nearest(); };
      const go = (index, instant = false) => {
        if (!cards.length) return;
        current = Math.max(0, Math.min(lastIndex(), index));
        pending = true;
        paint();
        clearTimeout(timer);
        track.scrollTo({left: target(current), behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        timer = setTimeout(settle, 600);
      };
      previous.addEventListener('click', () => go(current - 1), {signal});
      next.addEventListener('click', () => go(current + 1), {signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? lastIndex() : current + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      const release = () => { pending = false; clearTimeout(timer); };
      track.addEventListener('pointerdown', release, {passive: true, signal});
      track.addEventListener('wheel', release, {passive: true, signal});
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => { if (!pending) nearest(); });
        clearTimeout(timer);
        timer = setTimeout(settle, 140);
      }, {passive: true, signal});
      track.addEventListener('scrollend', settle, {signal});
      const resize = new ResizeObserver(() => go(current, true));
      resize.observe(track);
      this.cleanup = () => { clearTimeout(timer); cancelAnimationFrame(frame); resize.disconnect(); };
      section.querySelector('[data-arrival-controls]').hidden = !cards.length;
      paint();
    }
    disconnectedCallback() { this.controller?.abort(); this.cleanup?.(); this.controller = null; }
  });
  const initialize = root => {
    root.querySelectorAll('[data-arrival-classic]').forEach(section => {
      if (!section.querySelector(elementTag)) section.append(document.createElement(elementTag));
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
